module.exports = __webpack_public_path__ + "static/subgrid-ff4d04a7241542272da5cd77a98ee284.png";